export default __webpack_public_path__ + "static/media/icon-metrics-air-flow-rate.749bae24.svg";